export const SITE_CONFIG = {
  brandName: 'Estrategias Digitales A-Z',
  whatsappNumber: '50685316690',
  email: 'holaestrategiasaz@gmail.com',
  location: 'Costa Rica',
  product: {
    name: 'Página Web Profesional A-Z',
    price: '₡120.000',
    deliveryDays: 7,
    paymentPolicy:
      '50% para iniciar el proyecto. 50% antes de publicar la versión final.',
    scope: {
      sections: 'Hasta seis secciones principales',
      services: 'Hasta diez servicios',
      products: 'Hasta veinte productos iniciales',
      revisions: 'Dos rondas de revisión',
    },
  },
  social: {
    instagram: [
      'https://www.instagram.com/azestrategias/',
      'https://www.instagram.com/zunigaj96m/',
    ],
    facebook: [
      'https://www.facebook.com/profile.php?id=61587921394872',
      'https://www.facebook.com/javier.zuniga.7106/',
    ],
  },
  analytics: {
    ga4MeasurementId: '',
    metaPixelId: '1243214431067357',
    searchConsoleVerification: '',
  },
  seo: {
    title:
      'Páginas Web Profesionales en Costa Rica | Estrategias Digitales A-Z',
    description:
      'Creamos páginas web profesionales para negocios, comercios y servicios en Costa Rica. WhatsApp, dominio y hosting incluidos por ₡120.000, pago único.',
    ogTitle: 'Tu negocio merece una página profesional',
    ogDescription:
      'Mostrá tus productos o servicios y llevá a tus clientes directamente a WhatsApp.',
  },
  restaurantSeo: {
    title: 'Menú Digital con Pedidos por WhatsApp para Restaurantes | A-Z',
    description:
      'Creamos menús digitales para restaurantes y cafeterías en Costa Rica, con categorías, carrito y pedidos directos por WhatsApp. ₡120.000, pago único.',
    ogTitle: 'Un menú digital listo para recibir pedidos por WhatsApp',
    ogDescription:
      'Organizá tus productos, recibí pedidos completos y mostrale a tus clientes un menú claro desde cualquier celular.',
  },
} as const

export const WHATSAPP_MESSAGES = {
  hero: 'Hola, vi la página de Estrategias Digitales A-Z y quiero información sobre la página web de ₡120.000, pago único. Mi negocio se llama ______ y se dedica a ______.',
  professional:
    'Hola, quiero la versión Página de Servicios de la Página Web Profesional A-Z. Mi negocio se llama ______ y se dedica a ______.',
  catalog:
    'Hola, quiero la versión Catálogo con pedidos por WhatsApp de la Página Web Profesional A-Z. Mi negocio se llama ______ y se dedica a ______.',
  price:
    'Hola, quiero comenzar mi Página Web Profesional A-Z de ₡120.000. Mi negocio se llama ______ y se dedica a ______.',
  portfolio:
    'Hola, estuve viendo los proyectos de A-Z y quiero cotizar una página similar para mi negocio. Mi negocio se llama ___.',
  restaurant:
    'Hola, quiero mi menú digital de ₡120.000, pago único. Mi restaurante o cafetería se llama ______.',
  diagnostic:
    'Hola, quiero solicitar el diagnóstico digital gratuito para mi negocio. El negocio se llama ______ y se dedica a ______.',
  final:
    'Hola, quiero comenzar mi Página Web Profesional A-Z de ₡120.000. Mi negocio se llama ______ y se dedica a ______.',
  general:
    'Hola, quiero consultar sobre la Página Web Profesional A-Z para mi negocio.',
} as const

export const PORTFOLIO_PROJECTS = [
  {
    name: 'NatuCafé',
    category: 'Restaurante y pedidos',
    description: 'Menú digital con productos, carrito y pedidos directos.',
    url: 'https://noizacr.com/r/natucafe-coffee-shop',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://noizacr.com/r/natucafe-coffee-shop',
    accent: '#67d19b',
    recommendedForRestaurants: true,
  },
  {
    name: 'Emilius Pizza',
    category: 'Restaurante y delivery',
    description:
      'Menú digital personalizado con pedidos y opciones de entrega.',
    url: 'https://noizacr.com/r/emilius-pizza',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://noizacr.com/r/emilius-pizza',
    accent: '#f07a56',
  },
  {
    name: 'NOIZA',
    category: 'Marketplace gastronómico',
    description: 'Plataforma para descubrir restaurantes y realizar pedidos.',
    url: 'https://noizacr.com/',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://noizacr.com/',
    accent: '#d5ad3f',
  },
  {
    name: 'JAZUGA',
    category: 'Plataforma empresarial',
    description:
      'Presencia digital para una empresa especializada en sistemas y certificación de Gas LP.',
    url: 'https://jazuga.com/',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://jazuga.com/',
    accent: '#f4a51c',
  },
  {
    name: 'DMT',
    category: 'Producto digital',
    description:
      'Experiencia editorial e informativa para un producto especializado.',
    url: 'https://dmt.crecimientoaudiopro.com/',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://dmt.crecimientoaudiopro.com/',
    accent: '#c86cff',
  },
  {
    name: 'Estrategias Digitales A-Z',
    category: 'Servicios profesionales',
    description:
      'Página comercial enfocada en presentar una oferta y generar consultas por WhatsApp.',
    url: '#',
    previewUrl:
      'https://image.thum.io/get/width/1200/crop/800/noanimate/https://az.estrategiasdigitalesaz.com/',
    accent: '#20d6e8',
  },
] as const

export const RESTAURANT_PROJECTS = PORTFOLIO_PROJECTS.slice(0, 2)

export const FAQS = [
  {
    question: '¿La página tiene mensualidad?',
    answer:
      'El paquete incluye dominio y hosting durante el primer año. Antes de finalizar ese periodo te informaremos el costo de renovación. No existe una mensualidad obligatoria durante el primer año para mantener el paquete básico.',
  },
  {
    question: '¿En cuánto tiempo estará lista?',
    answer:
      'La entrega estimada es de siete días hábiles después de recibir toda la información necesaria. Funciones especiales o retrasos en el envío de materiales pueden modificar el plazo.',
  },
  {
    question: '¿Qué debo enviar para comenzar?',
    answer:
      'Logo, colores, información del negocio, servicios o productos, fotografías, ubicación, horarios, redes sociales y número de WhatsApp.',
  },
  {
    question: '¿Puedo solicitar cambios?',
    answer:
      'Sí. El paquete incluye dos rondas de revisión. Los cambios adicionales o modificaciones de alcance se cotizan por separado.',
  },
  {
    question: '¿La página aparecerá en Google?',
    answer:
      'Configuramos la estructura técnica básica para que pueda ser encontrada e indexada. La posición final depende de distintos factores y no se garantiza una ubicación específica.',
  },
  {
    question: '¿Puedo vender productos?',
    answer:
      'Sí. Podemos incluir un catálogo y un carrito que prepare el pedido y lo envíe directamente a WhatsApp. Los pagos en línea se cotizan como una integración adicional.',
  },
  {
    question: '¿Puedo actualizar el inventario?',
    answer:
      'La versión comercial puede permitir marcar productos disponibles o agotados. Sistemas avanzados de inventario, varias bodegas o sincronización con otros sistemas se cotizan aparte.',
  },
  {
    question: '¿Incluye fotografías y videos?',
    answer:
      'El cliente suministra el material inicial. La producción profesional de fotografías o videos puede cotizarse como servicio adicional.',
  },
  {
    question: '¿Puedo usar mi propio dominio?',
    answer:
      'Sí. Podemos conectar un dominio existente o registrar uno nuevo según disponibilidad.',
  },
  {
    question: '¿Qué pasa después del primer año?',
    answer:
      'Te contactaremos antes del vencimiento para coordinar la renovación del dominio y hosting.',
  },
  {
    question: '¿Trabajan solamente con restaurantes?',
    answer:
      'No. Creamos páginas para restaurantes, comercios, profesionales, clínicas, consultores y empresas de servicios.',
  },
  {
    question: '¿La página reemplaza mis redes sociales?',
    answer:
      'No. La página complementa tus redes y centraliza la información para que las personas puedan conocer el negocio y contactarte más fácilmente.',
  },
] as const

export const RESTAURANT_FAQS = [
  {
    question: '¿El cliente puede armar el pedido desde el celular?',
    answer:
      'Sí. El menú puede organizarse por categorías y permitir que el cliente agregue productos a un carrito antes de enviar el pedido completo a tu WhatsApp.',
  },
  {
    question: '¿Puedo mostrar productos agotados?',
    answer:
      'Sí. Incluimos un control básico para marcar productos disponibles o agotados. Inventarios avanzados o sincronización con otros sistemas se cotizan por separado.',
  },
  {
    question: '¿Incluye pagos en línea?',
    answer:
      'El paquete prepara el pedido para WhatsApp. Las pasarelas de pago en línea son una funcionalidad especial y se cotizan por separado.',
  },
  {
    question: '¿En cuánto tiempo estará listo mi menú digital?',
    answer:
      'La entrega estimada es de siete días hábiles después de recibir el menú, precios, fotos, horarios y demás información necesaria.',
  },
  {
    question: '¿Qué necesitan para comenzar?',
    answer:
      'Logo, colores, menú con precios y categorías, fotografías, ubicación, horarios, redes sociales y el número de WhatsApp que recibirá los pedidos.',
  },
  {
    question: '¿Qué pasa después del primer año?',
    answer:
      'El dominio y hosting están incluidos por un año. Antes del vencimiento te informaremos el costo de renovación.',
  },
] as const
